import React, { useEffect, useState } from "react";
import dynamic from 'next/dynamic';
import Head from 'next/head'
import Image from 'next/image'
import { Inter } from 'next/font/google'
import styles from '../../styles/Home.module.css'

import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import Layout from '../../../components/layout';

const FaceMeshComponent = dynamic(() => import('../../../components/facemesh'), {
    ssr: false
  });
  
export async function getServerSideProps({ query }) {
  // 
  let faceShapeTemp = ["Oval"];
  if (query.faceShape) {
    faceShapeTemp = Array.isArray(query.faceShape) ? query.faceShape : [query.faceShape];
  }
  // const [faceShape, setFaceShape] = useState(faceShapeTemp);
  
  return {
    props: {
      // page: query.page || null,
      faceShape: faceShapeTemp,      
      // setFaceShape: setFaceShape,
    },
  };
}

export default function HomePage({ faceShape }) {
return (
  <>
<Head>
  <title>Best Blush Placement | Personalized AI Makeup Guidance</title>
  <link
    rel="canonical"
    href="https://stylesense.io/makeup-recommendations/blush-placement"
    key="canonical"
  />
  <meta
    name="description"
    content="What blush suits your face best? Let our AI tell you - our website provides follow-along blush filters tailored to your face shape. Just like using a TikTok or Snapchat filter, our AR technology overlays blush guides in real-time and uses advanced algorithms to analyze your facial features. Follow our personalized recommendations to enhance your natural look, and find your signature style."     
    key="desc"
  />
  <meta name="keywords" content="blush placement, makeup guides, personalized makeup, AI makeup, AR makeup, face shape analysis, beauty tech" />
  <meta property="og:title" content="Perfect Blush Placement | Personalized Makeup Guidance with AI" />
  <meta property="og:description" content="Find out how our AI can help you achieve the ideal blush placement for your face shape. Personalized, easy-to-follow guides for a flawless look!" />
  <meta property="og:url" content="https://stylesense.io/makeup-recommendations/blush-placement" />
  <meta property="og:type" content="website" />
  <meta name="twitter:title" content="Perfect Blush Placement | Personalized Makeup Guidance with AI" />
  <meta name="twitter:description" content="Enhance your natural beauty with our AI-powered blush placement guides. Tailored to your unique face shape, our AR technology makes it simple and fun!" />
  <link rel="icon" href="/favicon.ico" />
</Head>
    {/* <main className={styles.main}>
    <Navbar />
    <FaceMeshComponent page={"makeup_recommendations/blush_placement"} faceShape={ faceShape }/>     
    <Footer />
    </main> */}
    <Layout page={"makeup_recommendations/blush_placement"} faceShape={ faceShape } selectedOption={"makeup_recommendations/blush_placement"}/>
  </>
  )
}

// export default HomePage;